import React from 'react';
import PropTypes from 'prop-types';

import { H4, Text } from 'components/core/Typography';
import { Group } from 'components/core/Page';
import { ClickToShowNumberButton } from 'components/contact/ClickToShowNumberButton';

import './callCenterBanner.scss';

export function CallCenterBanner({ getTollfreePhoneNumber, locationString }) {
	const bannerText = locationString ? `Need help finding a moving truck or storage in ${locationString}?` : 'Need help? SpareFoot answers in 10 seconds or less.';
	return (
		<div className="call-center-banner">
			<Group>
				<H4
					size="large"
				>
					{bannerText}
				</H4>
			</Group>
			<Group>
				<Text
					size="medium"
					color="gray"
					weight="standard"
				>
					Give us a call. We'll help you find the best deal on storage.
				</Text>
			</Group>
			<ClickToShowNumberButton
				className="phone-number-button"
				outline
				size="standard"
				fetchPhoneNumber={getTollfreePhoneNumber}
			/>
		</div>

	);
}

CallCenterBanner.propTypes = {
	getTollfreePhoneNumber: PropTypes.func,
	locationString: PropTypes.string
};

export default CallCenterBanner;
